import { render, staticRenderFns } from "./FeaturedRestaurants.vue?vue&type=template&id=14d2edaa&lang=pug&"
import script from "./FeaturedRestaurants.vue?vue&type=script&lang=js&"
export * from "./FeaturedRestaurants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports